import React, { useEffect, useState } from "react";

//redux
import { useDispatch, useSelector } from "react-redux";

//action
import { getPurchaseTransactions } from "../../store/coinPlan/action";

//pagination
import Pagination from "../../pages/Pagination";

//routing
import { Link } from "react-router-dom";

import PurchaseTransaction from "./history/PurchaseTransaction";

const PurchaseTransactionsHistory = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { purchaseTransactions, purchaseTransactionsTotal } = useSelector(
    (state) => state.coinPlan
  );


  useEffect(() => {
    dispatch(getPurchaseTransactions(activePage, rowsPerPage)); // eslint-disable-next-line
  }, [activePage, rowsPerPage]);

  useEffect(() => {
    setData(purchaseTransactions);
  }, [purchaseTransactions]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Purchase Transactions</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Purchase Transactions
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card" id="card">
            <div className="card-body card-overflow pt-0">
              <PurchaseTransaction data={data} />
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={purchaseTransactionsTotal}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseTransactionsHistory;
